<template>
<b-container class="py-3 px-0">

    <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent" v-if="monografie.data" v-html="monografie.data.title"></b-card>

    <b-card class="shadow px-1 pt-1 pb-4 rounded bg-transparent">
        <div v-if="loading">
            <div class="text-center">
                <b-spinner variant="primary" label="Se incarca..."></b-spinner>
            </div>
        </div>
        <b-card-text>
            <div v-for="p in monografie.pdf" :key="p.id">
                <div v-html="p.titlu.replace('Înapoi la harta cu monografii','')"></div>
                <div class="justify-content-center my-2">
                    
                    <b-button @click="onClick(p.link)" class="ml-1 my-1" v-if="p.link.includes('.pdf')">
                        <b-icon icon="cloud-download" aria-hidden="true" class="pr-2"></b-icon> Descarcă
                    </b-button>
                    <b-button @click="showPdffun(p.link)" class="ml-1 my-1" v-if="p.link.includes('.pdf')">
                        <b-icon icon="book" aria-hidden="true" class="pr-2"></b-icon> Afișează
                    </b-button>

                </div>
                <div class="justify-content-center my-2">
                    <b-button @click="onClick(p.link)" class="ml-1 my-1" v-if="p.link.includes('.docx')">
                        <b-icon icon="cloud-download" aria-hidden="true" class="pr-2"></b-icon> Descarcă
                    </b-button>
                </div>
                <div class="justify-content-center my-2">
                    <b-button @click="onClick(p.link)" class="ml-1 my-1" v-if="p.link.includes('.xlsx')">
                        <b-icon icon="cloud-download" aria-hidden="true" class="pr-2"></b-icon> Descarcă
                    </b-button>
                </div>

            </div>
        </b-card-text>
    </b-card>

    <vuepdflook @closepdf="closepdf" v-model="isshowpdf" :pdfurl="pdfurls" @pdferr="pdferr" :maxscale='4' :minscale='0.1' :scale='0.6'></vuepdflook>
</b-container>
</template>

<script>
import vuepdflook from 'vuepdflook'

export default {
    data() {
        return {
            monografie: [],
            pdfurls: '',
            isshowpdf: false,
            loading: 'true',
        };
    },
    methods: {
        closepdf() {
            this.isshowpdf = false
        },
        pdferr(errurl) {
            console.log(errurl);
        },
        showPdffun(value) {
            this.pdfurls = value;
            this.isshowpdf = true;
        },
        loadPosts() {
            fetch('https://app.bibliotecaarad.ro/backend/api/iamon/' + this.$route.params.slug)
                .then(response => response.json())
                .then(data => {
                    this.monografie = data;
                });
        },
        onClick(value) {
            var ext = '';
            if (value.includes('.pdf')) {
                ext = '.pdf';
            }
            if (value.includes('.docx')) {
                ext = '.docx';
            }
            if (value.includes('.xlsx')) {
                ext = '.xlsx';
            }
            fetch(value)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(myBlob => {
                    var fileURL = window.URL.createObjectURL(new Blob([myBlob]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.$route.params.slug + ext);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(error => {
                    console.error('There has been a problem with your fetch operation:', error);
                });

        }
    },
    created() {
        this.loadPosts();
        setTimeout(() => {
            this.loading = false;
        }, 6000);
    },
    components: {
        vuepdflook
    },

};
</script>
